export const useAuthenticationOptions = () => {
  const passwordLoginEnabled = ref(false)
  const loading = ref(false)
  const { authenticationOptions } = useRequest()

  const refresh = async () => {
    loading.value = true
    try {
      const response = await authenticationOptions({ globalLoading: false, suppressErrorToast: true, cache: "no-store", retry: 0, getCachedData: () => undefined })
      passwordLoginEnabled.value = !response?.error?.value
        && response?.data?.value?.passwordLoginEnabled === true
    } catch {
      passwordLoginEnabled.value = false
    } finally {
      loading.value = false
    }
  }

  onMounted(refresh)
  return { passwordLoginEnabled, authenticationOptionsLoading: loading, refreshAuthenticationOptions: refresh }
}
